export default __webpack_public_path__ + "static/media/welcome-male@2x.721ec60a.png";